import "../styles/BasicFooter.css";

export const BasicFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="basic-footer" role="contentinfo" id="index-footer">
      <div className="basic-footer__inner">
        {/* Left: Brand / blurb / socials */}
        <div className="basic-footer__brand">
          <div className="basic-footer__brandName">Rezify</div>
          <div className="basic-footer__brandTagline">
            From Campus to Career.
          </div>

          <div className="basic-footer__socials" aria-label="Rezify social links">
            {/* Replace hrefs with your real URLs */}
            <a
              className="basic-footer__socialBtn"
              href="https://www.linkedin.com/company/rezifyai"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.15 1.45-2.15 2.95v5.66H9.29V9h3.41v1.56h.05c.47-.9 1.62-1.85 3.34-1.85 3.57 0 4.23 2.35 4.23 5.41v6.33ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM3.56 20.45h3.56V9H3.56v11.45Z"
                />
              </svg>
            </a>

            <a
              className="basic-footer__socialBtn"
              href="https://www.instagram.com/rezify.ai"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              title="Instagram"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 2A3.75 3.75 0 0 0 4 7.75v8.5A3.75 3.75 0 0 0 7.75 20h8.5A3.75 3.75 0 0 0 20 16.25v-8.5A3.75 3.75 0 0 0 16.25 4h-8.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm5.75-2.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Right: columns */}
        <div className="basic-footer__cols">
          <div className="basic-footer__col">
            <div className="basic-footer__colTitle">Contact</div>
            <a className="basic-footer__link" href="mailto:sales@rezify.ai">
              sales@rezify.ai
            </a>
            <a className="basic-footer__link" href="mailto:support@rezify.ai">
              support@rezify.ai
            </a>
            <a className="basic-footer__link" href="/get_demo">Request Demo</a>
          </div>

          <div className="basic-footer__col">
            <div className="basic-footer__colTitle">Platform</div>
            <a className="basic-footer__link" href="/index">Features</a>
            <a className="basic-footer__link" href="/plans">Pricing</a>
            <a className="basic-footer__link" href="https://www.youtube.com/embed/zgzaiHOiOmc">Demo Video</a>
            <a className="basic-footer__link" href="/plans">Sign Up</a>
          </div>

          <div className="basic-footer__col">
            <div className="basic-footer__colTitle">Resources</div>
            <a className="basic-footer__link" href="/help">Help</a>
            <a className="basic-footer__link" href="/feedback">Feedback</a>
            <a className="basic-footer__link" href="/privacynotice">Privacy</a>
            <a className="basic-footer__bottomLink" href="/vpat">VPAT</a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="basic-footer__bottom">
        <div className="basic-footer__bottomInner">
          <div className="basic-footer__copyright">
            © {year} Rezify® — All rights reserved.
          </div>

          <div className="basic-footer__bottomLinks">
            <a className="basic-footer__bottomLink" href="/privacynotice">Privacy</a>
            <a className="basic-footer__bottomLink" href="/vpat">VPAT</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
